import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.18501 2.67708C9.64695 0.774305 12.3531 0.774305 12.815 2.67709C13.1134 3.90626 14.5216 4.48957 15.6018 3.83142C17.2739 2.81259 19.1874 4.7261 18.1686 6.3982C17.5104 7.47836 18.0937 8.88661 19.3229 9.18501C21.2257 9.64695 21.2257 12.3531 19.3229 12.815C18.0937 13.1134 17.5104 14.5216 18.1686 15.6018C19.1874 17.2739 17.2739 19.1874 15.6018 18.1686C14.5216 17.5104 13.1134 18.0937 12.815 19.3229C12.3531 21.2257 9.64695 21.2257 9.18501 19.3229C8.88661 18.0937 7.47836 17.5104 6.3982 18.1686C4.7261 19.1874 2.81259 17.2739 3.83142 15.6018C4.48957 14.5216 3.90626 13.1134 2.67709 12.815C0.774305 12.3531 0.774305 9.64695 2.67708 9.18501C3.90626 8.88661 4.48957 7.47836 3.83142 6.3982C2.81259 4.72609 4.7261 2.81259 6.3982 3.83142C7.47836 4.48957 8.88661 3.90626 9.18501 2.67708Z" />
    <path d="M14.25 11C14.25 12.7949 12.7949 14.25 11 14.25C9.20507 14.25 7.75 12.7949 7.75 11C7.75 9.20507 9.20507 7.75 11 7.75C12.7949 7.75 14.25 9.20507 14.25 11Z" />
  </svg>
);
